<div class="profile-page w-full max-w-[820px] mx-auto px-4 py-6 space-y-6">
  <!-- ============ HEADER / BANNER CARD ============ -->
  <div class="profile-card header-card overflow-hidden">
    <!-- Cover banner -->
    <div class="banner-wrap">
      <img
        src="Images/Spinner/creative-background-online-casino-male-hand-smartphone-playing-cards-inscription-poker-black-gold-internet-gambling-197363112.webp"
        alt=""
        class="banner-img"
      />
      <div class="banner-fade"></div>
    </div>

    <!-- Info row (overlaps banner) -->
    <div class="px-4 pb-4 -mt-8 flex flex-col sm:flex-row sm:items-end gap-3">
      <!-- Avatar + change photo -->
      <div class="flex flex-col items-center gap-1 shrink-0">
        <div
          class="avatar-wrap relative group cursor-pointer"
          (click)="saveUserProfileImage()"
        >
          <div class="avatar-frame">
            <img
              [src]="profileImage || defaultAvatar"
              alt="Profile Picture"
              class="avatar-img object-cover"
            />
          </div>
          <!-- hover dim overlay -->
          <div class="avatar-overlay"></div>
          <!-- gold camera badge -->
          <span class="avatar-badge" aria-hidden="true">
            <svg
              class="w-2.5 h-2.5"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
              />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
              />
            </svg>
          </span>
        </div>
        <button
          type="button"
          (click)="saveUserProfileImage()"
          class="change-photo mt-0.5"
        >
          Change Photo
        </button>
      </div>

      <!-- Name + username -->
      <div class="pb-1 min-w-0 text-center sm:text-left">
        <h1 class="name-h1 font-barlow text-white truncate">{{ name }}</h1>
        <p class="username">{{ "@" + username }}</p>
      </div>
    </div>
  </div>

  <!-- ============ LEVEL / RANK CARD ============ -->
  <div
    class="profile-card lvl-card p-4 relative overflow-hidden"
    (click)="openLevelModal()"
  >
    <!-- decorative top-left glow -->
    <div class="lvl-card-glow"></div>

    <div class="relative flex items-center gap-4">
      <!-- Medal -->
      <div class="lvl-badge shrink-0">
        <img src="Images/profile/bronze.png" alt="Rank medal" class="medal" />
      </div>

      <!-- Right column -->
      <div class="flex-1 min-w-0">
        <div class="flex items-center justify-between gap-2">
          <div class="min-w-0">
            <p class="rank-name font-barlow">
              {{ rankName }}<span class="rank-level">· Level {{ level }}</span>
            </p>
            <p class="xp-line">{{ xp }} XP</p>
          </div>
          <button type="button" class="view-all" (click)="openLevelModal()">
            View All
          </button>
        </div>

        <!-- Progress bar -->
        <div class="xp-track mt-3">
          <div class="xp-fill" [style.width.%]="xpPercent"></div>
        </div>
        <div class="flex items-center justify-between mt-1.5">
          <span class="xp-pct">{{ xpPercent }}%</span>
          <span class="xp-next"
            >{{ xpToNext | number }} XP to {{ nextRank }}</span
          >
        </div>

        <!-- Perk chips -->
        <div class="lvl-perk-row mt-3">
          <div class="perk-chip">
            <p class="pk-l">Score Redeem Limit</p>
            <p class="pk-v">${{ scoreRedeemLimit }}</p>
          </div>
          <div class="perk-chip">
            <p class="pk-l">Withdraw Limit</p>
            <p class="pk-v">${{ withdrawLimit }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ============ ACCOUNT INFO + BALANCES ============ -->
  <div class="grid md:grid-cols-2 gap-6">
    <!-- Account info -->
    <div class="profile-card p-6">
      <p class="caps-label mb-5">Account Info</p>

      <div class="space-y-5">
        <!-- Email -->
        <div class="flex items-center justify-between gap-3">
          <div class="min-w-0">
            <p class="caps-label mb-1">Email</p>
            <p class="font-jakarta text-white text-sm font-bold truncate">
              {{ email }}
            </p>
          </div>
          <button
            type="button"
            class="copy-btn"
            [class.copied]="copiedField === 'Email'"
            (click)="copyToClipboard(email, 'Email')"
            aria-label="Copy email"
          >
            <svg
              class="copy-ic w-4 h-4"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
            >
              <rect x="9" y="9" width="13" height="13" rx="2" />
              <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
            </svg>
            <svg
              class="check-ic w-4 h-4"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M20 6L9 17l-5-5"
              />
            </svg>
          </button>
        </div>

        <!-- Username -->
        <div class="flex items-center justify-between gap-3">
          <div class="min-w-0">
            <p class="caps-label mb-1">Username</p>
            <p class="font-jakarta text-white text-sm font-bold truncate">
              {{ "@" + username }}
            </p>
          </div>
          <button
            type="button"
            class="copy-btn"
            [class.copied]="copiedField === 'Username'"
            (click)="copyToClipboard(username, 'Username')"
            aria-label="Copy username"
          >
            <svg
              class="copy-ic w-4 h-4"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
            >
              <rect x="9" y="9" width="13" height="13" rx="2" />
              <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
            </svg>
            <svg
              class="check-ic w-4 h-4"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M20 6L9 17l-5-5"
              />
            </svg>
          </button>
        </div>

        <!-- Country -->
        <div class="min-w-0">
          <p class="caps-label mb-1">Country</p>
          <p class="font-jakarta text-white text-sm font-bold truncate">
            {{ country }}
          </p>
        </div>
      </div>
    </div>

    <!-- Balances -->
    <div class="profile-card p-6 flex flex-col">
      <p class="caps-label mb-5">Balances</p>

      <div class="space-y-4">
        <div class="flex items-center justify-between">
          <span class="wallet-label"
            ><span class="dot dot-gold"></span>Wallet</span
          >
          <span class="font-inter gold-light text-sm font-black"
            >${{ mainWallet | number: "1.2-2" }}</span
          >
        </div>
      </div>

      <div class="grid grid-cols-2 gap-3 mt-auto pt-5">
        <button type="button" class="btn-gold" (click)="openDepositModal()">
          <svg
            class="w-4 h-4"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            viewBox="0 0 24 24"
          >
            <path stroke-linecap="round" d="M12 5v14M5 12h14" />
          </svg>
          Deposit
        </button>
        <button type="button" class="btn-ghost" (click)="openWithdraw()">
          <svg
            class="w-4 h-4"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 5v14M19 12l-7 7-7-7"
            />
          </svg>
          Withdraw
        </button>
      </div>
    </div>
  </div>

  <!-- ============ VERIFY IDENTITY BANNER ============ -->
  <div class="profile-card p-5 flex items-center justify-between gap-4">
    <div class="flex items-center gap-4 min-w-0">
      <div class="verify-icon shrink-0">
        <svg
          class="w-5 h-5"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 2l7 4v6c0 5-3.5 8-7 10-3.5-2-7-5-7-10V6l7-4z"
          />
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M9 12l2 2 4-4"
          />
        </svg>
      </div>
      <div class="min-w-0">
        <p
          class="font-barlow text-white font-black uppercase tracking-wide leading-tight verify-your-identity"
        >
          Verify Your Identity
        </p>
        <p class="text-slate-400 text-[12.5px] truncate">
          Unlock card &amp; CashApp payments
        </p>
      </div>
    </div>
    <button
      type="button"
      class="btn-gold shrink-0 whitespace-nowrap"
      (click)="openKycForm()"
    >
      Verify Now
      <svg
        class="w-4 h-4"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M5 12h14M13 6l6 6-6 6"
        />
      </svg>
    </button>
  </div>

  <!-- ============ CHANGE PASSWORD BANNER ============ -->
  <div class="profile-card p-5 flex items-center justify-between gap-4">
    <div class="flex items-center gap-4 min-w-0">
      <div class="verify-icon shrink-0">
        <svg
          class="w-5 h-5"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          viewBox="0 0 24 24"
        >
          <rect x="5" y="11" width="14" height="9" rx="2" />
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M8 11V8a4 4 0 018 0v3"
          />
        </svg>
      </div>
      <div class="min-w-0">
        <p
          class="font-barlow text-white font-black uppercase tracking-wide leading-tight verify-your-identity"
        >
          Change Your Password
        </p>
        <p class="text-slate-400 text-[12.5px] truncate">
          Update your account password
        </p>
      </div>
    </div>
    <button
      type="button"
      class="btn-gold shrink-0 whitespace-nowrap"
      (click)="openChangePassword()"
    >
      Change Password
      <svg
        class="w-4 h-4"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M5 12h14M13 6l6 6-6 6"
        />
      </svg>
    </button>
  </div>

  <!-- ============ MY GAME ACCOUNTS ============ -->
  <div class="profile-card overflow-hidden">
    <!-- Header -->
    <div class="ga-head flex items-center justify-between px-4 py-3">
      <p class="caps-label">My Game Accounts</p>
      <span class="ga-badge">{{ gameAccounts.length }} active</span>
    </div>

    <!-- Grid -->
    <div class="ga-grid grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4">
      <div
        class="ga-tile"
        *ngFor="let g of gameAccounts"
        (click)="playGame(g.route)"
      >
        <div class="ga-icon">
          <img [src]="g.image" [alt]="g.name" />
        </div>
        <div class="w-full min-w-0 text-center">
          <p class="ga-name">{{ g.name }}</p>
          <p class="ga-user">{{ g.username }}</p>
        </div>
        <div class="ga-play">▶ Play</div>
      </div>
    </div>
  </div>
</div>

<!-- ============ LEVEL JOURNEY MODAL ============ -->
<div
  #lvlmBackdrop
  class="lvlm-backdrop"
  [class.hidden]="!showLevelModal"
  (click)="closeLevelModal()"
>
  <div class="lvlm-box" (click)="$event.stopPropagation()">
    <!-- top glow -->
    <div class="lvlm-glow"></div>

    <!-- header -->
    <div class="lvlm-head">
      <div class="min-w-0">
        <p class="lvlm-title font-barlow">Level Journey</p>
        <p class="lvlm-sub">
          Earn XP on every deposit &amp; spin to climb the ranks.
        </p>
      </div>
      <button
        type="button"
        class="lvlm-close"
        (click)="closeLevelModal()"
        aria-label="Close"
      >
        <svg
          class="w-4 h-4"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 6l12 12M18 6L6 18"
          />
        </svg>
      </button>
    </div>

    <!-- your XP -->
    <div class="lvlm-xp">
      <span class="lvlm-xp-label">Your XP</span>
      <span class="lvlm-xp-val font-barlow">{{ xp | number }}</span>
    </div>

    <!-- ladder -->
    <div class="lvlm-scroll">
      <div class="lvlm-ladder">
        <div
          class="lvlm-row"
          [ngClass]="'lvlm-' + lvl.state"
          *ngFor="let lvl of levels"
        >
          <!-- timeline rail -->
          <div class="lvlm-rail">
            <span class="lvlm-node">
              <span
                class="lvlm-node-dot"
                *ngIf="lvl.state === 'current'"
              ></span>
              <svg
                *ngIf="lvl.state === 'locked'"
                class="lvlm-node-ic"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                viewBox="0 0 24 24"
              >
                <rect x="5" y="11" width="14" height="9" rx="2" />
                <path d="M8 11V8a4 4 0 018 0v3" />
              </svg>
              <svg
                *ngIf="lvl.state === 'unlocked'"
                class="lvlm-node-ic"
                fill="none"
                stroke="currentColor"
                stroke-width="3"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </span>
          </div>

          <!-- medal -->
          <div class="lvlm-badge-wrap">
            <img
              *ngIf="lvl.img"
              [src]="lvl.img"
              [alt]="lvl.name"
              class="lvlm-badge-img"
            />
            <div *ngIf="!lvl.img" class="lvlm-badge-fallback">
              {{ lvl.icon }}
            </div>
          </div>

          <!-- info -->
          <div class="lvlm-row-info">
            <div class="flex items-center gap-2 flex-wrap">
              <p class="lvlm-name font-barlow">{{ lvl.name }}</p>
              <span class="lvlm-lvl">Level {{ lvl.level }}</span>
              <span class="lvlm-here" *ngIf="lvl.state === 'current'"
                >You are here</span
              >
            </div>

            <p class="lvlm-xpline" [class.is-current]="lvl.state === 'current'">
              🔒
              <ng-container *ngIf="lvl.state === 'current'"
                >{{ lvl.xp | number }} XP</ng-container
              >
              <ng-container *ngIf="lvl.state !== 'current'"
                >Unlock at {{ lvl.unlockXp | number }} XP</ng-container
              >
            </p>

            <div class="lvlm-perks">
              <span class="lvlm-perk">
                <span class="lvlm-perk-label">Score limit</span>
                <span class="lvlm-perk-val">${{ lvl.scoreLimit }}</span>
              </span>
              <span class="lvlm-perk">
                <span class="lvlm-perk-label">Withdraw</span>
                <span class="lvlm-perk-val">${{ lvl.withdraw }}</span>
              </span>
            </div>
          </div>

          <!-- status pill -->
          <div class="lvlm-status">
            <span
              class="lvlm-pill"
              [ngClass]="{
                'lvlm-pill-current': lvl.state === 'current',
                'lvlm-pill-done': lvl.state === 'unlocked',
                'lvlm-pill-locked': lvl.state === 'locked',
              }"
            >
              {{
                lvl.state === "current"
                  ? "Current"
                  : lvl.state === "unlocked"
                    ? "Done"
                    : "Locked"
              }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ============ ADD FUNDS MODAL ============ -->
<div #addFundsBackdrop>
  <div
    *ngIf="showAddFunds"
    class="fixed inset-0 bg-black/80 flex items-center justify-center af-overlay"
    (click)="closeAddFunds()"
  >
    <div
      class="w-full max-w-lg overflow-hidden af-modal"
      (click)="$event.stopPropagation()"
    >
      <!-- Header -->
      <div class="af-head flex items-center justify-between">
        <div class="flex items-center gap-2.5">
          <div class="hex-logo shrink-0">
            <span class="text-[#E5B236] font-black text-base">R</span>
          </div>
          <div class="flex flex-col">
            <h2 class="af-title">Add Funds</h2>
            <p class="af-balance">
              Balance: <b>${{ mainWallet | number: "1.2-2" }}</b>
            </p>
          </div>
        </div>
        <button
          type="button"
          (click)="closeAddFunds()"
          aria-label="Close"
          class="w-8 h-8 flex items-center justify-center rounded-lg border border-slate-600/60 text-gray-400 hover:text-white hover:border-gray-500 transition-colors shrink-0"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>

      <!-- Payment method list -->
      <div class="pm-list af-body">
        <div class="pm-section" *ngFor="let section of fundSections">
          <span class="pm-section-label">
            <!-- lightning glyph for Instant -->
            <svg
              *ngIf="section.lead === 'bolt'"
              class="pm-lead-ic"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M13 2L4.5 13.5H11l-1 8.5 8.5-11.5H12l1-8.5z" />
            </svg>
            <!-- bitcoin glyph for Crypto -->
            <span *ngIf="section.lead === 'bitcoin'" class="pm-lead-b">₿</span>
            {{ section.label }}
          </span>

          <div class="pm-row" *ngFor="let m of section.methods">
            <div class="flex items-center gap-3">
              <div
                class="pm-icon-box"
                [class.pm-icon-gold]="m.icon === 'card-gold'"
              >
                <!-- brand logo image -->
                <img
                  *ngIf="m.img"
                  [src]="m.img"
                  [alt]="m.title"
                  class="max-w-full max-h-full object-contain"
                />
                <!-- gold card glyph -->
                <svg
                  *ngIf="m.icon === 'card-gold'"
                  class="pm-glyph pm-glyph-gold"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <rect x="2" y="5" width="20" height="14" rx="2.5" />
                  <path stroke-linecap="round" d="M2 10h20" />
                  <path stroke-linecap="round" d="M6 15h4" />
                </svg>
                <!-- white card glyph -->
                <svg
                  *ngIf="m.icon === 'card'"
                  class="pm-glyph pm-glyph-white"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <rect x="2" y="5" width="20" height="14" rx="2.5" />
                  <path stroke-linecap="round" d="M2 10h20" />
                  <path stroke-linecap="round" d="M6 15h4" />
                </svg>
                <!-- apple glyph -->
                <svg
                  *ngIf="m.icon === 'apple'"
                  class="pm-glyph pm-glyph-apple"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path
                    d="M17.05 12.9c-.03-2.6 2.12-3.85 2.22-3.9-1.21-1.77-3.1-2.01-3.77-2.04-1.6-.16-3.13.94-3.94.94-.81 0-2.07-.92-3.4-.9-1.75.03-3.36 1.02-4.26 2.58-1.82 3.16-.47 7.84 1.3 10.4.86 1.26 1.89 2.67 3.24 2.62 1.3-.05 1.79-.84 3.36-.84 1.57 0 2.01.84 3.39.81 1.4-.02 2.28-1.28 3.14-2.55.99-1.46 1.4-2.87 1.42-2.94-.03-.02-2.72-1.05-2.75-4.14zM14.6 5.32c.72-.87 1.2-2.08 1.07-3.28-1.03.04-2.28.69-3.02 1.55-.66.77-1.24 2-1.09 3.18 1.15.09 2.32-.58 3.04-1.45z"
                  />
                </svg>
                <!-- bitcoin glyph -->
                <svg
                  *ngIf="m.icon === 'bitcoin'"
                  class="pm-glyph pm-glyph-btc"
                  viewBox="0 0 24 24"
                >
                  <circle cx="12" cy="12" r="11" fill="#F7931A" />
                  <path
                    fill="#fff"
                    d="M16.2 10.6c.2-1.35-.83-2.08-2.24-2.56l.46-1.84-1.12-.28-.45 1.79c-.29-.07-.6-.14-.9-.21l.45-1.8-1.12-.28-.46 1.84c-.24-.06-.48-.11-.71-.17v-.01l-1.55-.39-.3 1.2s.83.19.82.2c.46.11.54.42.52.66l-.52 2.1c.03.01.07.02.12.04l-.12-.03-.74 2.94c-.06.14-.2.35-.52.27.01.02-.82-.2-.82-.2l-.56 1.29 1.46.36c.27.07.54.14.8.21l-.47 1.87 1.12.28.46-1.84c.31.08.6.16.9.23l-.46 1.83 1.12.28.47-1.86c1.91.36 3.35.22 3.96-1.51.49-1.39-.02-2.2-1.03-2.72.73-.17 1.29-.65 1.44-1.65zm-2.57 3.59c-.35 1.39-2.69.64-3.45.45l.62-2.46c.76.19 3.2.56 2.83 2.01zm.35-3.61c-.32 1.27-2.27.62-2.9.47l.56-2.24c.63.16 2.66.45 2.34 1.77z"
                  />
                </svg>
              </div>
              <div class="flex flex-col">
                <span class="pm-title">{{ m.title }}</span>
                <span class="pm-subtitle">{{ m.subtitle }}</span>
              </div>
            </div>

            <div class="pm-meta">
              <div class="pm-bonus">+{{ m.bonus }}%</div>
              <div class="flex items-center gap-2">
                <div
                  class="pm-status"
                  [class.pm-status-green]="m.tone === 'green'"
                  [class.pm-status-gold]="m.tone === 'gold'"
                >
                  <div
                    class="pm-dot"
                    [style.background]="
                      m.tone === 'green' ? '#2EBA72' : '#FFB800'
                    "
                  ></div>
                  {{ m.status }}
                </div>
                <svg
                  class="w-3.5 h-3.5 text-gray-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>

        <p class="pm-footer">Min deposit $5.00</p>
      </div>
    </div>
  </div>
</div>

<!-- ============ WITHDRAW MODAL ============ -->
<div #withdrawBackdrop>
  <div
    *ngIf="showWithdraw"
    class="fixed inset-0 flex items-center justify-center af-overlay wd-overlay"
    (click)="closeWithdraw()"
  >
    <div
      class="w-full max-w-lg overflow-hidden wd-modal"
      (click)="$event.stopPropagation()"
    >
      <!-- Header -->
      <div class="wd-head flex items-center justify-between">
        <div class="flex items-center gap-3">
          <div class="wd-hicon shrink-0">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 19V5M5 12l7-7 7 7"
              />
            </svg>
          </div>
          <div class="flex flex-col">
            <h2 class="wd-title">Withdraw</h2>
            <div class="wd-sub-row">
              <p class="wd-sub">
                <span class="wd-sub-l">Balance:</span>
                <span class="wd-sub-v-gold"
                  >${{ mainWallet | number: "1.2-2" }}</span
                >
              </p>
              <p class="wd-sub">
                <span class="wd-sub-l">Limit:</span>
                <span class="wd-sub-v-yellow">${{ withdrawLimit }}</span>
              </p>
            </div>
          </div>
        </div>
        <button
          type="button"
          (click)="closeWithdraw()"
          aria-label="Close"
          class="wd-x flex items-center justify-center shrink-0"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>

      <div class="wd-body">
        <!-- Manual review banner -->
        <div class="wd-banner">
          <div class="wd-banner-icon-box">
            <svg
              class="wd-banner-ic"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <circle cx="12" cy="12" r="9" />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 8v4l3 2"
              />
            </svg>
          </div>
          <div class="min-w-0">
            <p class="wd-banner-title">Manual Review · Min $30</p>
            <p class="wd-banner-sub">
              All withdrawals are reviewed and processed within 2 hours
            </p>
          </div>
        </div>

        <div class="wd-methods-wrap">
          <!-- Section label -->
          <div class="dm-section-label">
            <svg
              class="w-3 h-3 shrink-0"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 4h8a2 2 0 012 2v6a2 2 0 01-2 2h-8a2 2 0 01-2-2v-6a2 2 0 012-2z"
              />
            </svg>
            Select Withdrawal Method
            <span class="dm-sec-rule"></span>
          </div>

          <!-- Withdrawal methods -->
          <div class="wd-methods">
            <div class="dm-method-btn" *ngFor="let w of withdrawMethods">
              <div class="flex items-center gap-3 min-w-0">
                <div class="dm-method-icon">
                  <img [src]="w.img" [alt]="w.title" />
                </div>
                <div class="flex flex-col min-w-0">
                  <span class="dm-method-title">{{ w.title }}</span>
                  <span class="dm-method-sub">{{ w.sub }}</span>
                </div>
              </div>
              <svg
                class="dm-method-chev shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>
          </div>
        </div>

        <!-- Info footer -->
        <div class="dm-info-box">
          <div class="dm-info-line" *ngFor="let line of withdrawInfo">
            <span class="dm-info-dot"></span>
            <p class="dm-info-text">
              {{ line.pre
              }}<span class="dm-info-strong" *ngIf="line.strong">{{
                line.strong
              }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
